import styled from "styled-components";
import { ReactComponent as LogoSvg } from "../../images/svg/logo.svg";
import { Link } from "react-router-dom";
import { ReactComponent as LogoSide } from "./logo-side.svg";
import { ReactComponent as LogoVert } from "./logo-vert.svg";

const Logo = ({
  width = "5rem",
  variant = false
}: {
  width?: string;
  variant?: boolean;
}) => {
  return (
    <Container>
      <LogoContainer to={"/"}>
        {variant ? <LogoVert width={width} /> : <LogoSide width={width} />}
      </LogoContainer>
    </Container>
  );
};

export default Logo;

const Container = styled.div`
  display: block;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`;

const LogoContainer = styled(Link)`
  position: relative;
  cursor: pointer;
`;
